// extracted by mini-css-extract-plugin
module.exports = {"modalErrorTips":"ModalErrorTips_modalErrorTips__y7Y0X","alertMsg":"ModalErrorTips_alertMsg__3C7Xl"};